import { render, staticRenderFns } from "./Planboard.vue?vue&type=template&id=f3c7c77a&scoped=true&lang=pug&"
import script from "./Planboard.vue?vue&type=script&lang=js&"
export * from "./Planboard.vue?vue&type=script&lang=js&"
import style0 from "./Planboard.vue?vue&type=style&index=0&id=f3c7c77a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c7c77a",
  null
  
)

export default component.exports